/**
 * JWT Token Utilities
 * 
 * JWT token decode ve expiry check fonksiyonları.
 * Tüm fonksiyonlar invalid token durumunda gracefully fail eder (null döner, crash olmaz).
 */

import jwtDecode from 'jwt-decode';

/**
 * JWT token'ı decode et
 * 
 * @param {string} token - JWT token to decode
 * @returns {Object|null} Decoded token payload or null if invalid
 * 
 * @example
 * const payload = decodeToken('eyJhbGci...');
 * // Returns: { userId: '123', email: 'test@example.com', exp: 1730604800, ... }
 */
export const decodeToken = (token) => {
  if (!token) return null;
  
  try {
    return jwtDecode(token);
  } catch (error) {
    // Invalid token format, corrupted, etc.
    console.warn('Token decode failed:', error.message);
    return null;
  }
};

/**
 * Token'ın expire olup olmadığını kontrol et
 * 
 * @param {string} token - JWT token to check
 * @returns {boolean} True if expired, false if valid, true if invalid token
 * 
 * @example
 * if (isTokenExpired(token)) {
 *   // Token expired, logout user
 * }
 */
export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  
  if (!decoded || !decoded.exp) {
    // Invalid token or no expiry field - consider as expired
    return true;
  }
  
  // JWT exp is in seconds, Date.now() is in milliseconds
  // Convert Date.now() to seconds by dividing by 1000
  const currentTime = Date.now() / 1000;
  
  return decoded.exp < currentTime;
};

/**
 * Token'ın expire tarihini Date object olarak döner
 * 
 * @param {string} token - JWT token
 * @returns {Date|null} Expiry date or null if invalid token
 * 
 * @example
 * const expiry = getTokenExpiry(token);
 * console.log(expiry.toLocaleString()); // "27.10.2025 14:30:00"
 */
export const getTokenExpiry = (token) => {
  const decoded = decodeToken(token);
  
  if (!decoded || !decoded.exp) {
    return null;
  }
  
  // JWT exp is in seconds, convert to milliseconds for Date constructor
  return new Date(decoded.exp * 1000);
};


